import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-dashboard-project-invite-request',
    templateUrl: './project-invitation-request.component.html',
    styleUrls: ['./project-invitation-request.component.scss'],
    standalone: false
})
export class ProjectInviteRequestComponent {
  @Input() public vendorName: string;
  @Input() public vendorLogo: string;
  @Input() public opportunityId: string;
  @Input() public opportunityName: string;
  @Input() public noQuoteStatus = false;
  @Input() public intentToQuote = false;
  @Input() public pendingInvite = false;

  @Output() public invitationAccepted = new EventEmitter<void>();
  @Output() public companyClicked = new EventEmitter<void>();
  @Output() public opportunityClicked = new EventEmitter<void>();
  @Output() public invitationDenied = new EventEmitter<void>();

  public companyClick(event: Event): void {
    event.stopPropagation();
    this.companyClicked.emit();
  }

  public opportunityClick(event: Event): void {
    event.stopPropagation();
    this.opportunityClicked.emit();
  }

  public declineProject(): void {
    this.invitationDenied.emit();
  }

  public acceptProject(): void {
    this.invitationAccepted.emit();
  }
}
